// src/lib/kinema/konva/renderers/ImageRenderer.ts
import Konva from 'konva';
import type { KonvaRenderer } from './types';
import type { BaseLayerData } from '../../core/types';

export const ImageRenderer: KonvaRenderer = {
  create(layer: BaseLayerData): Konva.Node {
    const konvaImage = new Konva.Image({
      image: undefined as unknown as HTMLImageElement,
      width: layer.width,
      height: layer.height,
    });

    if (layer.src) {
      loadImage(layer.src, konvaImage);
    }

    return konvaImage;
  },

  update(node: Konva.Node, layer: BaseLayerData, changed: Record<string, boolean>): void {
    if (changed.src && layer.src) {
      loadImage(layer.src, node as Konva.Image);
    }
    if (changed.width) node.setAttr('width', layer.width);
    if (changed.height) node.setAttr('height', layer.height);
  },

  destroy(node: Konva.Node): void { node.destroy(); },
};

function loadImage(src: string, konvaImage: Konva.Image): void {
  const img = new window.Image();
  img.crossOrigin = 'anonymous';
  img.src = src;
  img.onload = () => {
    konvaImage.image(img);
    konvaImage.getLayer()?.batchDraw();
  };
}
